import { FC, ReactNode } from "react"

import { Skeleton } from "@mui/material"
import { useSkeletonStatusProps } from "components/common/skeleton/skeleton.utils"

interface IProps {
  height: string
  width?: string
  style?: React.CSSProperties
  children?: ReactNode
}

const StudentSkeleton: FC<IProps> = ({
  children,
  width = "100%",
  height,
  style,
}) => {
  const skeletonStatusProps = useSkeletonStatusProps()

  return (
    <Skeleton
      width={width}
      height={height}
      style={style}
      {...skeletonStatusProps}
    >
      {children}
    </Skeleton>
  )
}

export default StudentSkeleton
